import { useRef } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { ITicketDistribution } from '../../../../../services/http/services/TicketsService';

interface IProps {
    data: ITicketDistribution[];
    colors: string[];
    onAnimationEnd: () => void;
}

export default function ChartTicketsDistribution({ data, colors, onAnimationEnd }: IProps) {

    const animationCompletedRef = useRef(false);

    const handleAnimationEnd = () => {
        if (animationCompletedRef.current) return; // já executou, ignora

        animationCompletedRef.current = true;

        setTimeout(() => {
            onAnimationEnd();
        }, 2000);
    };

    return (
        <PieChart width={315} height={230}>
            <Pie
                data={data as any}
                innerRadius={45}
                outerRadius={80}
                paddingAngle={3}
                dataKey="users_percentage"
                isAnimationActive={true}
                animationDuration={800}
                onAnimationEnd={handleAnimationEnd}
                label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
                    const RADIAN = Math.PI / 180;
                    const radius = outerRadius + 23; // aumenta a distância
                    const x = cx + radius * Math.cos(-midAngle * RADIAN);
                    const y = cy + radius * Math.sin(-midAngle * RADIAN);

                    return (
                        <text x={x} y={y} fill={colors[index]} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                            {percent * 100 < 100 ? (percent * 100).toFixed(2) : '100'}%
                        </text>
                    );
                }}
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${entry.range}`} fill={colors[index]} />
                ))}
            </Pie>

        </PieChart>
    );
}

